// src/pages/roles/PermissionList.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';
import permissionService from '../../services/permissionService';

const PermissionList = () => {
  const [permissions, setPermissions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPermssion = async () => {
      const response = await permissionService.getPermissions();
      setPermissions(response.data);
    };
    fetchPermssion();
  }, []);

  const handleDelete = async (id) => {
    await permissionService.deletePermission(id);
    setPermissions(permissions.filter((permission) => permission.id !== id));
  };

  return (
    <LayoutContainer>
      <AdminHeader title='Permissions' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/permission/new')}
          >
            Add Permission
          </Button>
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Permissions</TableCell>
              {/* <TableCell>Description</TableCell> */}
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {permissions.map((permission, index) => (
              <TableRow
                key={permission.id}
                sx={{
                  backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                  // '&:hover': { backgroundColor: '#e0f7fa' },
                }}
              >
                <TableCell>{permission.name}</TableCell>
                {/* <TableCell>{role.description}</TableCell> */}
                <TableCell>
                  <IconButton
                    onClick={() =>
                      navigate(`/permission/edit/${permission.id}`)
                    }
                  >
                    <EditIcon sx={{ color: '#be210b' }} />
                  </IconButton>
                  {/* <IconButton onClick={() => handleDelete(role.id)}>
                    <DeleteIcon sx={{ color: '#be210b' }} />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </LayoutContainer>
  );
};

export default PermissionList;
